import React, { useState, useContext, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import TFDoughnut from '../../../components/Charts/Doughnut';
import { DataGridPro, GridActionsCellItem, GridFooterContainer, GridToolbar } from '@mui/x-data-grid-pro';
import { ObjModal } from '../../../contexts';
import SendMassEmail from '../../Modals/SendMassEmail';
import SendMassTxt from '../../Modals/SendMassTxt';
import LogComms from '../../Modals/LogComms';
import { launchPhoneBurner } from '../../../common/utils';

import '../../../containers/Dashboard/dashboard.css';

const TFSegment = ( { aid, uid, stack, contacts, tasks, gameplan, loans, chartTitle, chartSub, chartData, gridTitle, gridData, gridActions } ) => {
    const [ selectedRows, setSelectedRows ] = useState( [] );
    const { openModal, closeModal, setModal } = useContext( ObjModal );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const apiRef = useRef( null );

    const handleSingleModal = ( t, cid, oid, onSave ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'log-call':
                console.log( 'log-call w/ cid: ' + cid );
                setModal( <LogComms commType='Call' close={closeModal} cid={cid} oid={oid} onSave={onSave} /> );
                break;

            case 'log-email':
                console.log( 'log-email w/ cid: ' + cid );
                setModal( <LogComms commType='Email' close={closeModal} cid={cid} oid={oid} onSave={onSave} /> );
                break;

            case 'log-sms':
                console.log( 'log-sms w/ cid: ' + cid );
                setModal( <LogComms commType='Txt' close={closeModal} cid={cid} oid={oid} onSave={onSave} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'unknown modeal type for single: ' + t + ' - ' + cid )  ;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleMassModal = async ( t ) => {
        let shouldOpen = true;

        let list = [];
        let cids = [];
        selectedRows.forEach( r => {
            const rtype = r.split( '_' )[0];
            switch ( rtype ) {
                case 'task':
                    const t = tasks[r];
                    if ( t && t.assoc && t.assoc.length ) {
                        const c = contacts[t.assoc[0].cid];
                        if ( c ) {
                            cids.push( c.cid );
                            list.push( c );
                        } else {
                            console.log( 'unknonw contact for: ', t.assoc );
                        }
                    }
                    break;

                case 'gp':
                    const g = gameplan[r];
                    if ( g ) {
                        const c = contacts[g.cid];
                        if ( c ) {
                            cids.push( c.cid );
                            list.push( c );
                        } else {
                            console.log( 'unknown contact for: ' + g.cid );
                        }
                    }
                    break;

                case 'con':
                    const c = contacts[r];
                    if ( c ) {
                        cids.push( c.cid );
                        list.push( c );
                    } else {
                        console.log( 'unknown contact for: ' + r );
                    }
                    break;

                case 'loan':
                    const lid = r.split( '::tf' )[0]
                    const l = loans[lid];
                    if ( l && l.borrowers && l.borrowers.length ) {
                        const c = contacts[l.borrowers[0].cid];
                        if ( c ) {
                            cids.push( c.cid );
                            list.push( c );
                        } else {
                            console.log( 'unknonw contact for: ', l.borrowers );
                        }
                    }
                    break;

                default:
                    console.log( 'unknown rtype: ' + r );
            }
            console.log( 'list: ', list );
        } );

        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} clist={cids} objType='contact' /> ); 
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} clist={cids} objType='contact' /> ); 
                break;
    
            case 'phoneburner':
                await launchPhoneBurner( aid, uid, cids, list, stack.dialer );
                shouldOpen = false;
                break;
        
            case 'export':
                apiRef.current.exportDataAsCsv();
                shouldOpen = false;
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    let cols = [
        { field: 'title', headerName: gridTitle, flex: 1, renderCell: ( { row } ) => {
            const url = ( row.lid ) ? `/loan/${row.lid}` : `/contact/${row.c?.cid}`;
            let extra = '';
            if ( row.c ) {
                if ( row.extraField && row.extraField === 'birthday' ) {
                    const bday = new Date( row.c.birthday + 'T12:00:00' );
                    extra = new Intl.DateTimeFormat( 'en-US', { month: 'short', day: 'numeric' } ).format( bday );
                } else if ( row.c.phoneMobile?.length ) {
                    extra = row.c.phoneMobile;
                } else if ( row.c.phone?.length ) {
                    extra = row.c.phone;
                }
            }
            return (
                <Row>
                    <Col className='py-2'>
                        <Row className='align-items-center'>
                            <Col>
                                <span  style={ { fontWeight: 500, fontSize: '14px' } }>
                                    <Link to={url}>{row.title}</Link>
                                </span>
                                <span className='ps-3'>{extra}</span>
                            </Col>
                        </Row>
                        <Row><Col style={ { fontSize: '11px' } }>{row.sub}</Col></Row>
                    </Col>
                </Row>
            )
        }, valueFormatter: ( { id, value } ) => {
            let out = value;
            if ( id.match( /^con_/ ) ) {
                const c = contacts[id];
                if ( c ) {
                    let addr = '';
                    let csz = '';
                    let bday = '';
                    if ( c.mailingAddress1 ) {
                        addr = c.mailingAddress1;
                        csz = `${c.mailingCity}, ${c.mailingState} ${c.mailingZip}`;
                    } else if ( c.homeAddress1 ) {
                        addr = c.homeAddress1;
                        csz = `${c.homeCity}, ${c.homeState} ${c.homeZip}`;
                    }
                    if ( c.birthday ) {
                        const bd = new Date( c.birthday.match( 'T' ) ? c.birthday : c.birthday + 'T12:00:00' );
                        bday = new Intl.DateTimeFormat( 'en-US', { month: 'short', day: 'numeric' } ).format( bd );
                    }
                    out = `${value}\n${addr}\n${csz}`;
                }
            }
            return out;
        } }
    ];
    if ( gridActions?.length ) {
        cols.push( { field: 'actions', type: 'actions', width: 100, getActions: ( { row } ) => gridActions.map( ( a, idx ) =>  <GridActionsCellItem icon={ a.icon } onClick={ () => handleSingleModal( a.type, row.c.cid, row.oid, a.onSave ) } label={a.label} showInMenu={a.dropdown} /> ) } );
    }

    const CustomFooter = ( { apiRef } ) => {
        return (
            <GridFooterContainer>
                <Container>
                    <Row className='align-items-center'>
                        <Col>
                            {
                                ( selectedRows.length > 0 ) ? (
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<KeyboardArrowDownIcon />} className='tf-button-transparent tf-hide-arrow'>
                                                {/* <Dropdown.Item onClick={ () => handleMassModal( 'email-mass' ) }>Send Email</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'sms-mass' ) }>Send Txt</Dropdown.Item> */}
                                                <Dropdown.Item onClick={ () => handleMassModal( 'export' ) }>Export to CSV</Dropdown.Item>
                                                {
                                                    hasPhoneBurner ? (
                                                        <Dropdown.Item onClick={ () => handleMassModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                ) : (
                                    null
                                )
                            }
                        </Col>
                        <Col className='text-end'>
                            Total: {gridData.length}
                        </Col>
                    </Row>
                </Container>
            </GridFooterContainer>
        );
    };

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );

    return (
        <Container fluid className='p-0 tf-segment-container' style={ { minWidth: '350px' } }>
            <Row className='p-0'>
                <Col>
                    <Row className='text-center py-3 mx-2'>
                        <Col>
                            <Row className='px-3'>
                                <Col className='w-100'>
                                    <TFDoughnut data={chartData} h='150px' title={chartTitle} sub={chartSub} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='mx-2'>
                        <Col>
                            <Row className='tf-dashboard-li-container overflow-auto pb-2'>
                                <Col style={ { height: '300px' } }>
                                    <DataGridPro
                                        apiRef={apiRef}
                                        // loading={ gridData.length === 0 }
                                        rows={gridData}
                                        columns={cols}
                                        checkboxSelection
                                        disableSelectionOnClick
                                        slots={ { 
                                            footer: CustomFooter,
                                            moreActionsIcon: KeyboardArrowDownIcon
                                        } }
                                        slotProps={ { toolbar: {
                                            footer: { apiRef }
                                        } } }
                                        onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                        getRowHeight={ () => 'auto' }
                                        getRowClassName={ ( params ) => {
                                            if ( gridTitle.match( /calls/i ) ) {
                                                if ( params.row.id.match( /^task/ ) ) {
                                                    return 'tf-gp-grid-task-row';
                                                } else if ( params.row.sub === 'Birthday Call' ) {
                                                    return 'tf-gp-grid-bday-row';
                                                }
                                            }
                                            return '';
                                        } }
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    stack: state.user.stack,
    contacts: state.contacts.byId,
    tasks: state.tasks.byId,
    gameplan: state.gameplan.byId,
    loans: state.loans.byId,
    // leadopps: state.leadopps.byId,
    // loanStatus: state.user.meta.loan.picklist.status,
    // globalStatus: state.user.meta.global.picklist.status,
} );
  
const mapDispatch = ( dispatch ) => ( {
    // loadNotes: dispatch.contacts.loadContactNotes
} );
  
export default connect( mapProps, mapDispatch )( TFSegment );